var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VRadiosWithValidation',_vm._b({attrs:{"row":"","radio-inputs":_vm.radioInputs},model:{value:(_vm.computedValue),callback:function ($$v) {_vm.computedValue=$$v},expression:"computedValue"}},'VRadiosWithValidation',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }